import { render } from "./GeneralJournal.vue?vue&type=template&id=61c223bc&scoped=true&ts=true"
import script from "./GeneralJournal.vue?vue&type=script&lang=ts"
export * from "./GeneralJournal.vue?vue&type=script&lang=ts"

import "./GeneralJournal.vue?vue&type=style&index=0&id=61c223bc&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Medix_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c223bc"]])

export default __exports__